import React from "react";
import * as styles from "./RecruitHeader.module.scss"
import { RecruitHeaderPc,RecruitHeaderSp } from "./index";
import { useBreakpoint } from 'gatsby-plugin-breakpoints'


const RecruitHeader = ({pageName})=>{
    const breakpoints = useBreakpoint();

  return(
    <header className={`${styles.RecruitHeader}`}>
      {
        breakpoints.tb ?
          <RecruitHeaderSp pageName={pageName} />
          :
          <RecruitHeaderPc pageName={pageName} />
      }
    </header>
  )
}
export default RecruitHeader